import React from 'react';
import PropTypes from 'prop-types';

const FiltersPopupMobileTop = ({
  hasAppliedFilters,
  filterLabel,
  clearFiltersLabel,
  onClearFilters,
  onClose,
}) => (
  <section className='ken-plp__filters__mobile-popup__top'>
    <span className='--label'>{filterLabel}</span>
    <section className='--right-section'>
      {hasAppliedFilters && (
        <button type='button' className='--clear-cta' onClick={onClearFilters}>
          {clearFiltersLabel}
        </button>
      )}
      <button type='button' className='--close-cta' onClick={onClose}>
        <i className='ken-icon ken-icon--close' />
      </button>
    </section>
  </section>
);

FiltersPopupMobileTop.propTypes = {
  hasAppliedFilters: PropTypes.bool,
  filterLabel: PropTypes.string,
  clearFiltersLabel: PropTypes.string,
  onClearFilters: PropTypes.func,
  onClose: PropTypes.func,
};

FiltersPopupMobileTop.defaultProps = {
  hasAppliedFilters: false,
  filterLabel: 'Filters',
  clearFiltersLabel: 'Clear all',
  onClearFilters: null,
  onClose: null,
};

export default FiltersPopupMobileTop;
